// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"35b2825e","908":"77a8a98b"}[chunkId] + ".chunk.js";
};